import {
  PREV_RESPONSES_PAGE,
  FETCH_NEXT_RESPONSES_PAGE,
  FETCHED_OWN_RESPONSES,
  FETCHED_RESPONSES,
  FETCHED_RESPONSE,
  FETCHING_RESPONSE,
  NEXT_RESPONSES_PAGE,
  DELETE_RESPONSE
} from "../actions/responses";
import { LOCATION_CHANGE } from "react-router-redux";
import responseReducer from "./response";
import { UPDATE_FISHERY_METADATA } from "../actions/response";
import { FETCH_NEXT_USER_RESPONSES, USER_RESPONSES_FETCHED } from '../hooks/useResponses';
import { FETCH_NEXT_USER_SEARCH_RESPONSES, SEARCH_USER_RESPONSES_FETCHED, NEW_USER_SEARCH } from '../hooks/useSearchResponses';

const findInAllResponses = (id, state) => {
  const { pages } = state.allResponses;
  for (const key in pages) {
    const page = pages[key];
    if (page.items && page.items.length) {
      for (const response of page.items) {
        if (response.metadata.id === id) {
          return response;
        }
      }
    }
  }
  return null;
}

const responses = (
  state = {
    fetching: false,
    items: [],
    searchItems: [],
    allResponses: {
      pages: {},
      cursors: [],
      currentCursor: null,
      fetching: false
    }
  },
  action
) => {
  switch (action.type) {
    case FETCH_NEXT_USER_RESPONSES:
      return {
        ...state,
        fetching: true
      };
    case USER_RESPONSES_FETCHED:
      let inserted = {};
      let combinedItems = [];
      for (const item of action.payload.items) {
        combinedItems.push(item);
        inserted[item.metadata.id] = true;
      }
      for (var item of state.items) {
        if (!inserted[item.metadata.id]) {
          combinedItems.push(item);
          inserted[item.metadata.id] = true;
        }
      }
      return {
        ...state,
        fetching: false,
        items: combinedItems.sort((a, b) => b.updatedAt - a.updatedAt),
        cursor: action.payload.cursor
      }
    case FETCHING_RESPONSE:
      return {
        ...state,
        fetching: true
      };
    // case FETCH_RESPONSES:
    //   return {
    //     ...state,
    //     allResponses: {
    //       ...state.allResponses,
    //       fetching: true
    //     }
    //   }
    case NEW_USER_SEARCH:
      return{
        ...state,
        searchItems: []
      }
    case FETCH_NEXT_USER_SEARCH_RESPONSES:
      return {
        ...state,
        fetching: true
      };
    case SEARCH_USER_RESPONSES_FETCHED:
      let insertedSearch = {};
      let combinedItemsSearch = [];
      for (const item of action.payload.items) {
        combinedItemsSearch.push(item);
        insertedSearch[item.metadata.id] = true;
      }
      for (var item of state.searchItems) {
        if (!insertedSearch[item.metadata.id]) {
          combinedItemsSearch.push(item);
          insertedSearch[item.metadata.id] = true;
        }
      }
      return {
        ...state,
        fetching: false,
        searchItems: combinedItemsSearch.sort((a, b) => b.updatedAt - a.updatedAt),
        searchCursor: action.payload.cursor
      }
    case FETCH_NEXT_RESPONSES_PAGE:
      return {
        ...state,
        allResponses: {
          ...state.allResponses,
          fetching: true
        }
      };
    case PREV_RESPONSES_PAGE:
      var { currentCursor, cursors } = state.allResponses;
      return {
        ...state,
        allResponses: {
          ...state.allResponses,
          currentCursor: cursors[cursors.indexOf(currentCursor) - 1]
        }
      };
    case NEXT_RESPONSES_PAGE:
      var { currentCursor, cursors } = state.allResponses;
      return {
        ...state,
        allResponses: {
          ...state.allResponses,
          currentCursor: cursors[cursors.indexOf(currentCursor) + 1]
        }
      };
    case FETCHED_RESPONSES:
      const cursor = action.cursor ? action.cursor.id : 0;
      return {
        ...state,
        allResponses: {
          ...state.allResponses,
          fetching: false,
          currentCursor: cursor,
          cursors: [...state.allResponses.cursors, cursor],
          pages: {
            ...state.allResponses.pages,
            [cursor]: {
              items: action.payload.items.map(r => {
                return {
                  ...r,
                  metadata: {
                    ...r["metadata"],
                    lastSynced: new Date().getTime()
                  }
                };
              }),
              nextCursor: action.payload.cursor,
              min: state.allResponses.cursors.length * action.pageSize + 1,
              max:
                state.allResponses.cursors.length * action.pageSize +
                action.payload.items.length
            }
          }
        }
      };
    case FETCHED_OWN_RESPONSES:
      console.log(action.payload);
      return {
        ...state,
        fetching: false,
        cursor: action.payload.cursor,
        items: action.payload.items.map(r => {
          return {
            ...r,
            metadata: {
              ...r["metadata"],
              lastSynced: new Date().getTime()
            }
          };
        })
      };
    case FETCHED_RESPONSE:
      return {
        ...state,
        items: [
          ...state.items.filter(r => r.id !== action.payload.metadata.id),
          action.payload
        ],
        fetching: false
      };
    case LOCATION_CHANGE:
      let path = action.payload.pathname;
      var id;
      if (/resultsReview/.test(path)) {
        id = path.match(/resultsReview\/(.*)\//)[1].split("/")[0];
      } else if (/questionnaire\/results/.test(path)) {
        id = path.match(/questionnaire\/results\/(.*)\//)[1].split("/")[0];
      } else if (
        /questionnaire\/(?!reference).*\/(monitoring|assessment|controlRules|enforcement)/.test(
          path
        )
      ) {
        id = path.match(/questionnaire\/(.*)\//)[1];
        id = id.split("/")[0];
      } else if (/home\/\w+/.test(path)) {
        id = path.match(/home\/(.*)/)[1];
      }
      return {
        ...state,
        responseID: id
      };
    case DELETE_RESPONSE:
      let allResponses = state.allResponses;
      state.allResponses.cursors.forEach(cursor => (allResponses.pages[cursor].items = allResponses.pages[cursor].items.filter(r => r.metadata.id !== action.id)));

      return {
        ...state,
        items: [
          ...state.items.filter(r => r.metadata.id !== action.id)
        ],
        searchItems: [
          ...state.searchItems.filter(r => r.metadata.id !== action.id)
        ],
        allResponses: {
          ...allResponses
        }
      };
    case UPDATE_FISHERY_METADATA:
      let response;
      response = state.items.find(r => r.metadata.id === action.responseID);
      if (!response) {
        response = findInAllResponses(action.responseID, state);
      }
      if (response) {
        return {
          ...state,
          items: [
            ...state.items.filter(i => i.metadata.id !== response.metadata.id),
            {
              ...response,
              ...action.attributes
            }
          ]
        };
      } else {
        return state;
      }
    default:
      if (action.response || action.responseID) {
        let response;
        if (action.responseID) {
          response = state.items.find(r => r.metadata.id === action.responseID);
          if (!response) {
            response = findInAllResponses(action.responseID, state);
          }
        } else {
          response = action.response;
        }
        if (!response) {
          throw new Error("Could not find response for action");
        }
        return {
          ...state,
          items: [
            ...state.items.filter(i => i.metadata.id !== response.metadata.id),
            {
              ...response,
              ...responseReducer(response, action)
            }
          ]
        };
      } else {
        return state;
      }
  }
};

export default responses;
